import { Form, Select } from 'antd';
import { useGetDistributionAreas } from 'api/statistic/use-get-distribution-areas';
import type { IDistributionAreaFormSelectProps } from './types';

export const DistributionAreaFormSelect = (props: IDistributionAreaFormSelectProps) => {
  const { name, label, placeholder, className, rootClassName, rules, allowClear, disabled, onChange } = props;

  const { data: distributionAreas } = useGetDistributionAreas();

  const options = distributionAreas?.map((area) => ({ value: area.slug, label: area.name }));

  return (
    <Form.Item name={name} label={label} className={className} rootClassName={rootClassName} rules={rules}>
      <Select
        options={options}
        placeholder={placeholder}
        allowClear={allowClear}
        disabled={disabled}
        onChange={onChange}
      />
    </Form.Item>
  );
};
